module.exports = __webpack_public_path__ + "static/scale-model-of-filoli-in-san-mateo-california-374e516cdc7e04cacd2df21e3fdd3883.png";